import { useGetWorker } from "@src/appV2/Worker/api/useGetWorker";

import { useIsSurfaceJobsEnabled } from "../../Placements/hooks/useIsSurfaceJobsEnabled";
import { getHasChildcareRoles } from "../util/childcareWorkerStorage";
import { useSelectedWorkType } from "./useSelectedWorkType";

export function useShouldShowJobsFirst(): boolean {
  const { data: worker } = useGetWorker();
  const isSurfaceJobsEnabled = useIsSurfaceJobsEnabled();
  const selectedWorkType = useSelectedWorkType();
  const hasChildcareRoles = getHasChildcareRoles(worker?.userId ?? "");

  const isChildcareWithBothWorkTypes =
    selectedWorkType.isFlexAndPermanentPlacementsOnboarding && hasChildcareRoles;

  // The worker's stored work-type preference must not depend on the
  // MSA-targeted `SURFACE_JOBS` flag — otherwise moving to a non-hiring MSA
  // flips the navbar order on a worker who explicitly chose "Find a job".
  // The childcare branch stays gated on the flag because it's still tied to
  // the hiring onboarding rollout.
  return (
    selectedWorkType.isPermanentPlacementsOnboarding ||
    (isSurfaceJobsEnabled && isChildcareWithBothWorkTypes)
  );
}
